<form #removeForm="ngForm" (ngSubmit)="apply()" novalidate>
  <h2 mat-dialog-title>Adding privileges for:</h2>
  <mat-dialog-content>
    <div class="pairs">
      <div class="row" *ngIf="donor">
        <span class="label">Donor:</span>
        <span class="value">{{ donor!.id }}</span>
        <span class="flex">{{ donor.firstName || "" }}</span>
      </div>
    </div>

    <mat-form-field appearance="fill">
      <mat-label>Limited to Centers</mat-label>
      <mat-select multiple [(ngModel)]="limitedToCenter" name="limitedToCenter">
        <mat-option *ngFor="let center of centers" [value]="center">
          {{ center.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-template #willRemove>
      <i>Are you sure you want to apply a request for this donor?</i>
    </ng-template>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="spacer"></div>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button type="submit" [disabled]="!removeForm.valid">Request</button>
  </mat-dialog-actions>
</form>
